import React from 'react';
import PropTypes from 'prop-types';
import Svg, { G, Path, Circle } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function MobileBrowserIcon(props) {
  const {
    color,
    ...svgProps
  } = props;

  return (
  <Svg 
    {...svgProps} 
    viewBox="0 0 75 75" >
    <G id="Mobile-Browser-Login" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <G id="Download-App-Play-Store" transform="translate(-243.000000, -211.000000)" stroke="#EC6B10">
            <G id="Group-3" transform="translate(244.000000, 212.000000)">
                <G id="Group-2" transform="translate(32.000000, 16.000000)">
                    <rect id="Rectangle-2" x="0.5" y="0.5" width="17" height="1" rx="0.5"></rect>
                    <rect id="Rectangle-2" transform="translate(17.500000, 7.000000) rotate(90.000000) translate(-17.500000, -7.000000) " x="11" y="7" width="13" height="1" rx="0.5"></rect>
                </G>
                <G id="Group-2" transform="translate(24.000000, 47.500000) rotate(180.000000) translate(-24.000000, -47.500000) translate(18.000000, 44.000000)">
                    <rect id="Rectangle-2" x="0.5" y="0.5" width="11" height="1" rx="0.5"></rect>
                    <rect id="Rectangle-2" transform="translate(11.500000, 3.500000) rotate(90.000000) translate(-11.500000, -3.500000) " x="8.5" y="3.5" width="6" height="1" rx="0.5"></rect>
                </G>
                <path d="M8.38021431,11.4594126 C3.65140135,17.2999308 0,25.8997084 0,34 C0,52.7776815 15.2223185,68 34,68 C43.096297,68 51.3582805,64.4278792 57.4597001,58.6098881 M63.6040005,50.7334345 C66.4024465,45.7931923 68,40.0831604 68,34 C68,15.2223185 52.7776815,0 34,0 C28.481123,0 23.2693614,1.31491685 18.6609141,3.64855143" id="Oval-2"></path>
                <Circle id="Oval" cx="18.5" cy="37.5" r="1.5"></Circle>
                <rect id="Rectangle" x="8.5" y="3.5" width="20" height="39" rx="4"></rect>
                <rect id="Rectangle" x="33.5" y="34.5" width="30" height="24" rx="2"></rect>
            </G>
        </G>
    </G>
</Svg>
  );
}

MobileBrowserIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

MobileBrowserIcon.defaultProps = {
  height: 45,
  width: 45,
};

export default pure(MobileBrowserIcon);
